import  { useEffect, useState } from 'react';
import { getEdital } from '@api/EditaisService';
import { EditalDetailsModal } from '@components/EditalDetailsModal';
import { Edital as EditalType } from '@libs/types';
import { Spin } from 'antd';
import { useSEO } from "@hooks/useSEO";

function buildJsonLd(edital: EditalType) {
  return {
    '@context': 'https://schema.org',
    '@type': 'GovernmentService',
    name: `Edital nº ${edital.numeroDoEdital} ? ${edital.nomeDoOrgaoPromotor}`,
    description: edital.finalidadeDeLicitacao || edital.modalidade,
    provider: {
      '@type': 'GovernmentOrganization',
      name: edital.nomeDoOrgaoPromotor,
      identifier: edital.cnpj,
    },
    areaServed: {
      '@type': 'AdministrativeArea',
      name: edital.cidade ? `${edital.cidade} ? ${edital.estado}` : edital.estado,
    },
    availableChannel: {
      '@type': 'ServiceChannel',
      serviceUrl: `https://jornaldolicitante.com.br/edital/${edital.uniqueId}`,
    },
    ...(edital.terminoDeRecebimento && {
      offers: {
        '@type': 'Offer',
        validThrough: edital.terminoDeRecebimento,
      },
    }),
  };
}

export const Edital = () => {
  // Identificador canônico da rota `/edital/$id` — é o `uniqueId` (Guid), não
  // mais o `id` numérico legado. Usado para o detalhe e a canonical URL.
  const uniqueId = window.location.href.split('edital/')[1]?.split('?')[0] ?? '';
  const [edital, setEdital] = useState<EditalType | null>(null);
  const [loading, setLoading] = useState(true);

  useSEO({
    title: edital
      ? `Edital nº ${edital.numeroDoEdital} ? ${edital.nomeDoOrgaoPromotor} | Jornal do Licitante`
      : 'Carregando edital... | Jornal do Licitante',
    description: edital
      ? `${edital.modalidade} ? ${edital.nomeDoOrgaoPromotor}${edital.cidade ? `, ${edital.cidade}/${edital.estado}` : ''}. Prazo: ${edital.terminoDeRecebimento ?? 'a confirmar'}.`
      : undefined,
    canonical: `https://jornaldolicitante.com.br/edital/${uniqueId}`,
    jsonLd: edital ? buildJsonLd(edital) : undefined,
  });

  useEffect(() => {
    getEdital(uniqueId).then((data) => {
      setEdital(data);
      setLoading(false);
    });
  }, [uniqueId]);

  if (loading) {
    return <Spin spinning={loading}>Carregando...</Spin>;
  }

  if (!edital) {
    return <div>Edital n�o encontrado</div>;
  }

  return <EditalDetailsModal edital={edital} isOpen={true} onClose={function (): void {
    throw new Error("Function not implemented.");
  }} />;
};
